import { useEffect } from 'react';
import airlineConfig from '../config/airline.config.json';

const BrandingLoader = () => {
    useEffect(() => {
        if (airlineConfig.seo?.title) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            document.title = airlineConfig.seo.title[lang] || airlineConfig.seo.title.ES || `${airlineConfig.airline.name} VA`;
        }

        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription && airlineConfig.seo?.description) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            metaDescription.content = airlineConfig.seo.description[lang] || airlineConfig.seo.description.ES || '';
        }

        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords && airlineConfig.seo?.keywords) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            metaKeywords.content = airlineConfig.seo.keywords[lang] || airlineConfig.seo.keywords.ES || '';
        }

        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle && airlineConfig.seo?.title) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            ogTitle.content = airlineConfig.seo.title[lang] || airlineConfig.seo.title.ES || '';
        }

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription && airlineConfig.seo?.description) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            ogDescription.content = airlineConfig.seo.description[lang] || airlineConfig.seo.description.ES || '';
        }

        const ogSiteName = document.querySelector('meta[property="og:site_name"]');
        if (ogSiteName) {
            ogSiteName.content = airlineConfig.airline?.name || 'Virtual Airline';
        }

        const twitterTitle = document.querySelector('meta[property="twitter:title"]');
        if (twitterTitle) {
            twitterTitle.content = `${airlineConfig.airline?.name || 'VA'} - ${airlineConfig.airline?.icaoCode || ''}`;
        }

        const twitterDescription = document.querySelector('meta[property="twitter:description"]');
        if (twitterDescription && airlineConfig.seo?.description) {
            const lang = navigator.language.substring(0, 2).toUpperCase();
            twitterDescription.content = airlineConfig.seo.description[lang] || airlineConfig.seo.description.ES || '';
        }

        const twitterImageAlt = document.querySelector('meta[property="twitter:image:alt"]');
        if (twitterImageAlt) {
            twitterImageAlt.content = `${airlineConfig.airline?.name || 'VA'} Logo`;
        }
    }, []);

    return null;
};

export default BrandingLoader;